import { civilDateFromIso, type HeldDraftInterval } from '@/lib/treatmentCourseWizard';

export type TreatmentCourseSlotSearchKeyInput = {
  clinicId: string;
  templateStepId?: string | null;
  bookedStepId?: string | null;
  windowStart?: string | null;
  windowEnd?: string | null;
  previousStartsAt?: string | null;
  practitionerIds?: string[] | null;
  held?: HeldDraftInterval[];
};

export type PortalTreatmentCourseSlotSearchKeyInput = {
  courseId: string;
  stepId: string;
  windowStart?: string | null;
  windowEnd?: string | null;
  practitionerIds?: string[] | null;
};

export function treatmentCourseStepSlotsQueryKey(
  input: TreatmentCourseSlotSearchKeyInput | null,
) {
  if (!input) return ['treatment-course-step-slots', null] as const;
  return [
    'treatment-course-step-slots',
    {
      clinicId: input.clinicId,
      templateStepId: input.templateStepId ?? null,
      bookedStepId: input.bookedStepId ?? null,
      windowStartDay: civilDateFromIso(input.windowStart ?? null),
      windowEndDay: civilDateFromIso(input.windowEnd ?? null),
      previousStartsAt: input.previousStartsAt ?? null,
      practitionerIds: [...(input.practitionerIds ?? [])].sort(),
      held: input.held ?? [],
    },
  ] as const;
}

export function portalTreatmentCourseSlotsQueryKey(
  input: PortalTreatmentCourseSlotSearchKeyInput | null,
) {
  if (!input) return ['portal', 'treatment-course-step-slots', null] as const;
  return [
    'portal',
    'treatment-course-step-slots',
    {
      courseId: input.courseId,
      stepId: input.stepId,
      windowStartDay: civilDateFromIso(input.windowStart ?? null),
      windowEndDay: civilDateFromIso(input.windowEnd ?? null),
      practitionerIds: [...(input.practitionerIds ?? [])].sort(),
    },
  ] as const;
}
